var _style, _desc, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNetwork2ArrowForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.25;fill:#FFFFFF;enable-background:new    ;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:none;stroke:#FF6666;stroke-width:2;stroke-dasharray:2,3;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Statusbar / BTN_Status_Icon_Pos1 / 00_statusbar_network_2_arrow_forward_48px_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "B_Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-488.000000, -1500.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons-_x2F_-Statusbar-_x2F_-BTN_x5F_Status_x5F_Icon_x5F_Pos1-_x2F_-00_x5F_statusbar_x5F_network_x5F_2_x5F_arrow_x5F_forward_x5F_48px_x5F_white"
  }, /*#__PURE__*/React.createElement("g", {
    id: "network_2",
    transform: "translate(2.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "network_x5F_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "st0",
    d: "M44,26V0l-4,2.5V26H44z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape_1_",
    className: "st0",
    d: "M30,20.2V8.6l4-2.5V26h-2v-7.8L30,20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape_2_",
    className: "st0",
    d: "M24,31.8V32h-4V14.7l4-2.4v13.9L21.2,29L24,31.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st1",
    d: "M14,32h-4V20.9l4-2.5V32z M4,24.5L0,27v5h4V24.5z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape_1_",
    className: "st1",
    points: "32,36 32,31 26,37 32,43 32,38 44,38 44,43 38,43 38,45 46,45 46,36  "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "dummy_icon_v2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line",
    className: "st2",
    d: "M1.2,1.2l45.5,45.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_1_",
    className: "st2",
    d: "M46.8,1.2L1.2,46.8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNetwork2ArrowForward);
export default __webpack_public_path__ + "static/media/icon-network_2_arrow_forward.3331a047e31bc95b990b4eafc6ab11ff.svg";
export { ForwardRef as ReactComponent };